import { useEffect, useRef } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import * as d3 from "d3";

export default function GraphPage() {
  const ref = useRef(null);

  const nodesMap = useRef({});
  const linksMap = useRef({});

  useEffect(() => {
    const width = ref.current.clientWidth;
    const height = ref.current.clientHeight;

    const svg = d3
      .select(ref.current)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .style("background", "#000")
      //.style("pointer-events", "none")

    const linkGroup = svg.append("g");
    const nodeGroup = svg.append("g");
    const labelGroup = svg.append("g");

    const simulation = d3
      .forceSimulation([])
      .force("link", d3.forceLink([]).id((d) => d.id).distance(80))
      .force("charge", d3.forceManyBody().strength(-200))
      .force("center", d3.forceCenter(width / 2, height / 2));

    function update() {
      let nodes = Object.values(nodesMap.current);
      let links = Object.values(linksMap.current);

      // ✅ ограничение
      nodes = nodes.slice(-120);

      const nodeIds = new Set(nodes.map((n) => n.id));

      // ✅ убираем битые links
      links = links.filter(
        (l) => nodeIds.has(l.source) && nodeIds.has(l.target)
      );

      links = links.slice(-200);

      // 🔗 LINKS
      const link = linkGroup.selectAll("line").data(links, (d) => d.id);

      link.enter()
        .append("line")
        .attr("stroke", "#333")
        .attr("stroke-width", 1);

      link.exit().remove();

      // 🔵 NODES
      const node = nodeGroup.selectAll("circle").data(nodes, (d) => d.id);

      const nodeEnter = node
        .enter()
        .append("circle")
        .attr("r", 6)
        .attr("fill", "#6bc1ff")
        .each((d) => {
          // ✅ фикс координат при создании
          if (d.x == null) {
            d.x = width / 2 + (Math.random() - 0.5) * 200;
            d.y = height / 2 + (Math.random() - 0.5) * 200;
          }
        })
       // .call(
        //  d3
          //  .drag()
          //  .on("start", dragstarted)
          //  .on("drag", dragged)
           // .on("end", dragended)
       // );

      nodeEnter
        .merge(node)
        .attr("r", (d) => Math.min(6 + d.count / 10, 18));

      node.exit().remove();

      // 🔤 LABELS
      const label = labelGroup.selectAll("text").data(nodes, (d) => d.id);

      label.enter()
        .append("text")
        .attr("font-size", 10)
        .attr("fill", "#aaa");

      label
        .merge(label)
        .text((d) => d.id.slice(0, 6));

      label.exit().remove();

      // ✅ ПРАВИЛЬНОЕ ОБНОВЛЕНИЕ simulation
      simulation.nodes(nodes);
      simulation.force("link").links(links);

      simulation.alpha(0.3).restart();

      function ticked() {
        linkGroup
          .selectAll("line")
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);

        nodeGroup
          .selectAll("circle")
          .attr("cx", (d) => d.x)
          .attr("cy", (d) => d.y);

        labelGroup
          .selectAll("text")
          .attr("x", (d) => d.x + 6)
          .attr("y", (d) => d.y + 6);
      }

      simulation.on("tick", ticked);
    }

    function dragstarted(event, d) {
      if (!event.active) simulation.alphaTarget(0.3).restart();
      d.fx = d.x;
      d.fy = d.y;
    }

    function dragged(event, d) {
      d.fx = event.x;
      d.fy = event.y;
    }

    function dragended(event, d) {
      if (!event.active) simulation.alphaTarget(0);
      d.fx = null;
      d.fy = null;
    }

    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const p = msg.payload || {};

        let from = p.from;
        let to = p.to;

        // ✅ fallback если нет from/to
        if (!from || !to) {
          const fakeA = "0x" + Math.random().toString(16).slice(2, 8);
          const fakeB = "0x" + Math.random().toString(16).slice(2, 8);
          from = fakeA;
          to = fakeB;
        }

        if (!nodesMap.current[from]) {
          nodesMap.current[from] = { id: from, count: 0 };
        }
        if (!nodesMap.current[to]) {
          nodesMap.current[to] = { id: to, count: 0 };
        }

        nodesMap.current[from].count++;
        nodesMap.current[to].count++;

        const key = from + "-" + to;

        if (!linksMap.current[key]) {
          linksMap.current[key] = {
            id: key,
            source: from,
            target: to,
          };
        }

        update();
      } catch {}
    };

    return () => ws.close();
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff" }}>
      <Header />

      <div style={{ padding: 16 }}>
        <h1 style={{ fontSize: 28 }}>🌐 Network Graph</h1>
      </div>

      <div ref={ref} style={{ height: "500px", width: "100%", overflow: "hidden" }} />

      <Footer />
    </div>
  );
}